import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useContent } from "@/contexts/ContentContext";

export function LinkEditButton({ path, title = "Edit link", testId }) {
  const { editMode, getByPath, setPath } = useContent();
  const [open, setOpen] = useState(false);
  const [val, setVal] = useState("");

  if (!editMode) return null;

  function openDialog() {
    setVal(getByPath(path) || "");
    setOpen(true);
  }
  function save() {
    setPath(path, val.trim());
    setOpen(false);
  }

  return (
    <>
      <button type="button" className="link-edit-btn" onClick={openDialog} title={title} data-testid={testId || `link-edit-${path}`}>
        🔗
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="cms-dialog">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
          <Input
            value={val}
            onChange={(e) => setVal(e.target.value)}
            placeholder="https://"
            data-testid={`${testId || `link-edit-${path}`}-input`}
          />
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button onClick={save} data-testid={`${testId || `link-edit-${path}`}-save`}>
              Save
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
